import React from 'react';
import Button from 'shared/components/UC/Button';
import styles from './FilePreviewModal.module.css';

interface Props {
  /** Nombre visible del archivo (título del modal). */
  title: string;
  /** URL del documento a previsualizar; null/undefined → placeholder (los
      archivos de ejemplo del prototipo no tienen documento asociado). */
  fileUrl?: string | null;
  /** Texto alternativo del placeholder (p. ej. formato no previsualizable). */
  placeholderText?: string;
  onClose: () => void;
}

// Modal de previsualización de archivos, mismo patrón que el modal de la
// Declaración de Singapur del Resumen del IR (overlay + header + visor).
// Reemplaza el window.open en nueva pestaña del panel del evaluador.
const FilePreviewModal: React.FC<Props> = ({
  title,
  fileUrl,
  placeholderText,
  onClose,
}) => {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Cerrar"
          >
            <i className="uc-icon">close</i>
          </button>
        </div>

        <div className={styles.viewerWrapper}>
          {fileUrl ? (
            <iframe src={fileUrl} className={styles.viewerFrame} title={title} />
          ) : (
            <div className={styles.placeholder}>
              <i className={`uc-icon ${styles.placeholderIcon}`}>description</i>
              <p className={styles.placeholderTitle}>
                Vista previa no disponible
              </p>
              <p className={styles.placeholderText}>
                {placeholderText ||
                  'Este archivo de ejemplo del prototipo no tiene un documento ' +
                    'asociado. En la plataforma real aquí se mostrará el documento.'}
              </p>
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <Button variant="primary" onClick={onClose}>Cerrar</Button>
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
